import stageTitleStyles from "site/components/exercise-stage-title/exercise-stage-title.module.css";

export { stageTitleStyles };

export function exerciseStageTitleMarkup() {
  return `<div class="${stageTitleStyles.stageTitleWrap}" let-stage="{{root.appService.curStage$::rx}}" let-step="{{root.appService.curStep$::rx}}">
    <h2
      class="${stageTitleStyles.stageTitle}"
      attached="{{root.appService.stageDescriptionText(step, stage, root.appService.uiLang$::rx)}}">
      {{root.appService.stageDescriptionText(step, stage, root.appService.uiLang$::rx)}}
    </h2>
  </div>`;
}
